import { produce } from 'immer';

const defaultState = {};

const reducer = produce((draft, action) => {}, defaultState);

export default reducer;
